<template>
  <DefaultSelect v-model.trim="selectValue" :placeholder="'請選擇年度及學期'" :items="ymsList" :itemText="'label'" :itemValue="'value'" :clearable="true" :errorsMsg="errorsMsg" labeltxt="請選擇年度及學期"></DefaultSelect>
</template>

<script>
import DefaultSelect from '@/components/Select/DefaultSelect.vue';

export default {
  name: 'YmsSelect',
  components: {
    DefaultSelect,
  },
  props: {
    value: {
      type: [String, Object],
    },
    funcId: {
      type: [String],
    },
    errorsMsg: {
      type: [String, Array],
    },
  },
  data() {
    return {
      ymsList: [],
    };
  },
  mounted() {
    this.doLoadYmsListSelector();
  },
  methods: {
    doLoadYmsListSelector() {
      const params = {
        funcId: this.funcId ? this.funcId : this.$route.meta.id,
      };
      return new Promise((resolve) => {
        $api.common.YmsListSelector(params).then((res) => {
          const { code, data } = res;
          if (code === 200) {
            // 學年學期資料清單
            this.ymsList = data;

            // 代入預設學年學期
            const selectItem = data.filter((x) => x.select === true)[0];
            if (selectItem) {
              this.selectValue = selectItem.value;
            }

            resolve(data);
          }
        });
      });
    },
  },
  computed: {
    selectValue: {
      get() {
        if (this.value === '') return '';
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.select {
  width: 160px;
  display: inline-block;
}
::v-deep.v-text-field.v-select .v-input__control .v-input__slot {
  input {
    line-height: initial;
  }
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 12px;
  background-color: $white;
  .v-input__append-inner {
    height: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
